export const isConflictErrorGuard = (error: unknown): boolean =>
  error instanceof Error && 'status' in error && error.status === 409;
